// The dotcom Node service runs one image in both testing and production, so
// values that differ between those deployments are read at runtime.
// next.config.js has the bundler replace `process.env.X` with build-time values,
// and it can follow aliases such as `const env = process.env` too. It can't
// resolve a key passed in as a variable, so these reads stay live on the server.
const { RENDER_ENV_COOKIE } = require('./lib/render-env-cookie');

const isServer = typeof window === 'undefined';

const readRuntimeEnv = (key) => {
  return process.env[key];
};

// Prebuilt pages were rendered at build time, with production values on both
// deployments, so the browser first trusts the cookie middleware sets with the
// values of the deployment that served the page.
const readRenderEnvCookie = () => {
  const cookie = document.cookie.split('; ').find((entry) => {
    return entry.startsWith(`${RENDER_ENV_COOKIE}=`);
  });
  if (!cookie) {
    return undefined;
  }
  try {
    return JSON.parse(
      decodeURIComponent(cookie.slice(RENDER_ENV_COOKIE.length + 1)),
    );
  } catch {
    return undefined;
  }
};

// The browser can't read the server's environment, so _document embeds the
// values the page was rendered with. Storybook and tests have no _document and
// keep using the build-time values.
const readRenderEnv = (key) => {
  if (isServer) {
    return readRuntimeEnv(key);
  }
  return (readRenderEnvCookie() || window.__RENDER_ENV__ || {})[key];
};

module.exports = {
  BLOG_ACCESS_TOKEN: isServer
    ? readRuntimeEnv('BLOG_ACCESS_TOKEN')
    : process.env.BLOG_ACCESS_TOKEN,
  BLOG_SPACE_ID: isServer
    ? readRuntimeEnv('BLOG_SPACE_ID')
    : process.env.BLOG_SPACE_ID,
  BUILD_MODE: process.env.BUILD_MODE,
  CONTENTFUL_ACCESS_TOKEN: isServer
    ? readRuntimeEnv('CONTENTFUL_ACCESS_TOKEN')
    : process.env.CONTENTFUL_ACCESS_TOKEN,
  CONTENTFUL_ENVIRONMENT: process.env.CONTENTFUL_ENVIRONMENT,
  CONTENTFUL_HOST: isServer
    ? readRuntimeEnv('CONTENTFUL_HOST')
    : process.env.CONTENTFUL_HOST,
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_SPACE_ID,
  DEPLOY_ROOT: process.env.DEPLOY_ROOT,
  INSTITUTIONS_PUBLIC_KEY: process.env.INSTITUTIONS_PUBLIC_KEY,
  MARKETO_BASE_URL: process.env.MARKETO_BASE_URL,
  NEXT_PUBLIC_HAPPO_RUN: process.env.NEXT_PUBLIC_HAPPO_RUN,
  NEXT_PUBLIC_IS_PREVIEW:
    readRenderEnv('NEXT_PUBLIC_IS_PREVIEW') ??
    process.env.NEXT_PUBLIC_IS_PREVIEW,
  NEXT_PUBLIC_PERCY_RUN: process.env.NEXT_PUBLIC_PERCY_RUN,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR:
    process.env.NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR,
  PARTNER_ACCESS_TOKEN: isServer
    ? readRuntimeEnv('PARTNER_ACCESS_TOKEN')
    : process.env.PARTNER_ACCESS_TOKEN,
  PARTNER_SPACE_ID: isServer
    ? readRuntimeEnv('PARTNER_SPACE_ID')
    : process.env.PARTNER_SPACE_ID,
  PERCY_TOKEN: process.env.PERCY_TOKEN,
  PLAID_COMMIT: process.env.PLAID_COMMIT,
  PLAID_ENV: readRenderEnv('PLAID_ENV') ?? process.env.PLAID_ENV,
  PORT: process.env.PORT,
  SEGMENT_WRITE_KEY: process.env.SEGMENT_WRITE_KEY,
};
